// import React, { useState } from "react";
// import Dash from "./Dash";
// import WebsiteHome from "./pages/WebsiteHome/WebsiteHome";
// import Login from "../src/pages/Login/Login.js"
// import Signup from "../src/pages/Login/Signup.js";
// import ForgotPassword from "../src/pages/Login/ForgotPassword.js"

// import ResetPassword from "../src/pages/Login/ResetPassword.js"

// function App() {
//   return (
//     <div>
//       <Dash />
//     </div>
//   );
// }

// export default App;

// import React, { useState } from "react";
// import Dash from "./Dash";

// const dummyUser = {
//   username: "dilamo",
//   password: "Dilamo@1988",
// };

// function App() {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [formData, setFormData] = useState({ username: "", password: "" });
//   const [error, setError] = useState("");

//   const handleLogin = (e) => {
//     e.preventDefault();
//     const { username, password } = formData;
//     if (username === dummyUser.username && password === dummyUser.password) {
//       setIsAuthenticated(true);
//       setError("");
//     } else {
//       setError("Invalid username or password.");
//     }
//   };

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   if (!isAuthenticated) {
//     return (
//       <div style={styles.container}>
//         <form style={styles.form} onSubmit={handleLogin}>
//           <h2 style={styles.title}>Welcome Back 👋</h2>
//           <p style={styles.subtitle}>Please login to access your dashboard</p>
//           <input
//             type="text"
//             name="username"
//             placeholder="Username"
//             value={formData.username}
//             onChange={handleChange}
//             style={styles.input}
//             required
//           />
//           <input
//             type="password"
//             name="password"
//             placeholder="Password"
//             value={formData.password}
//             onChange={handleChange}
//             style={styles.input}
//             required
//           />
//           <button type="submit" style={styles.button}>
//             Login
//           </button>
//           {error && <p style={styles.error}>{error}</p>}
//         </form>
//       </div>
//     );
//   }

//   return <Dash />;
// }

// const styles = {
//   container: {
//     minHeight: "100vh",
//     background: "linear-gradient(to right,rgb(245, 229, 145), #ec8a07)",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     padding: "20px",
//   },
//   form: {
//     background: "#fff",
//     padding: "40px",
//     borderRadius: "12px",
//     boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
//     width: "100%",
//     maxWidth: "400px",
//     textAlign: "center",
//   },
//   title: {
//     marginBottom: "10px",
//     color: "#333",
//     fontSize: "24px",
//   },
//   subtitle: {
//     marginBottom: "20px",
//     color: "#777",
//     fontSize: "14px",
//   },
//   input: {
//     width: "100%",
//     padding: "12px 15px",
//     margin: "10px 0",
//     border: "1px solid #ccc",
//     borderRadius: "8px",
//     fontSize: "16px",
//   },
//   button: {
//     width: "100%",
//     padding: "12px",
//     background: "#667eea",
//     color: "#fff",
//     fontSize: "16px",
//     border: "none",
//     borderRadius: "8px",
//     cursor: "pointer",
//     marginTop: "15px",
//     transition: "background 0.3s",
//   },
//   error: {
//     color: "#e74c3c",
//     marginTop: "10px",
//     fontSize: "14px",
//   },
// };

// export default App;

import React, { useState, useEffect } from "react";
import Dash from "./Dash";
import { useNavigate, Link } from "react-router-dom";
import { Navigate } from "react-router-dom";

// const dummyUser = {
//   username: "dilamo",
//   password: "Dilamo@1988",
// };

// function App() {

//   const [formData, setFormData] = useState({
//     email: "",
//     password: "",
//     rememberMe: false,
//   });
//   const [showPassword, setShowPassword] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const [username, setUsername] = useState("");

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setError("");
//     setSuccess("");

//     try {
//       const res = await fetch("http://localhost:3050/api/admin/adminlogin", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           email: formData.email,
//           password: formData.password,
//         }),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         // Store token and user info in localStorage
//         localStorage.setItem("token", data.token); // example: JWT token
//         localStorage.setItem("user", JSON.stringify(data.user)); // store user object
//         setIsAuthenticated(true);

//       } else {
//         // Show error
//         Error(data.message || "Login failed");
//       }
//       // if (!res.ok) throw new Error(data.message || "Login failed");

//       setSuccess("Login successful! Redirecting...");

//     } catch (err) {
//       setError(err.message);
//     }
//   };
//   useEffect(() => {
//     const storedUsername = localStorage.getItem("username");
//     if (storedUsername) {
//       setUsername(storedUsername);
//     }
//   }, []);

//   return (
//     <>
//       {!username ? (
//         <div className="login-container">
//           <form className="login-box" onSubmit={handleLogin}>
//             <h2>Login</h2>

//             <input
//               type="email"
//               name="email"
//               placeholder="Email"
//               required
//               value={formData.email}
//               onChange={handleChange}
//             />

//             <div className="password-field">
//               <input
//                 type={showPassword ? "text" : "password"}
//                 name="password"
//                 placeholder="Password"
//                 required
//                 value={formData.password}
//                 onChange={handleChange}
//               />
//               <button
//                 type="button"
//                 className="toggle-password"
//                 onClick={() => setShowPassword(!showPassword)}
//               >
//                 {showPassword ? "🙈" : "👁️"}
//               </button>
//             </div>

//             <div className="remember-forgot">
//               <label>
//                 <input
//                   type="checkbox"
//                   name="rememberMe"
//                   checked={formData.rememberMe}
//                   onChange={handleChange}
//                 />
//                 Remember Me
//               </label>
//               <Link to="/forgot-password" className="forgot-link">
//                 Forgot Password?
//               </Link>
//             </div>

//             <button type="submit" className="login-btn">
//               Login
//             </button>

//             {error && <p className="error">{error}</p>}
//             {success && <p className="success">{success}</p>}

//             <p className="signup-link">
//               Don't have an account? <Link to="/signup">Sign up</Link>
//             </p>
//           </form>
//         </div>
//       ) : (
//         <Dash />
//       )}
//     </>
//   );
// }

function App() {
  const API_URL = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(true);
  const [admin, setAdmin] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));
  // };

  // const handleLogin = async (e) => {
  //   e.preventDefault();
  //   setError("");
  //   setSuccess("");

  //   try {
  //     const res = await fetch(`${API_URL}/admin/adminlogin`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         email: formData.email,
  //         password: formData.password,
  //       }),
  //     });

  //     const data = await res.json();

  //     if (res.ok) {
  //       localStorage.setItem("token", data.token);
  //       localStorage.setItem("user", JSON.stringify(data.user));
  //       setSuccess("Login successful!");
  //       setUsername(data.user.username); // set the username state to show Dash
  //     } else {
  //       setError(data.message || "Login failed");
  //     }
  //   } catch (err) {
  //     setError("Network error. Please try again.");
  //   }
  // };

  // useEffect(() => {
  //   const storedUser = localStorage.getItem("user");
  //   if (storedUser) {
  //     const parsedUser = JSON.parse(storedUser);
  //     setUsername(parsedUser.username);
  //   }
  // }, []);

  return (
    <>
      {/* {!username ? (
        <div className="login-container">
          <form className="login-box" onSubmit={handleLogin}>
            <h2>Login</h2>

            <input
              type="email"
              name="email"
              placeholder="Email"
              required
              value={formData.email}
              onChange={handleChange}
            />

            <div className="password-field">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                required
                value={formData.password}
                onChange={handleChange}
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? "🙈" : "👁️"}
              </button>
            </div>

            <div className="remember-forgot">
              <label>
                <input
                  type="checkbox"
                  name="rememberMe"
                  checked={formData.rememberMe}
                  onChange={handleChange}
                />
                Remember Me
              </label>
              <Link to="/forgot-password" className="forgot-link">
                Forgot Password?
              </Link>
            </div>

            <button type="submit" className="login-btn">
              Login
            </button>

            {error && <p className="error">{error}</p>}
            {success && <p className="success">{success}</p>}

            <p className="signup-link">
              Don't have an account? <Link to="/signup">Sign up</Link>
            </p>
          </form>
        </div>
      ) : (
        // <Dash />
        <Navigate to="/" replace />
      )} */}
      <Dash />
    </>
  );
}

export default App;

const styles = {
  container: {
    minHeight: "100vh",
    background: "linear-gradient(to right,rgb(245, 229, 145), #ec8a07)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
  },
  form: {
    background: "#fff",
    padding: "40px",
    borderRadius: "12px",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
    width: "100%",
    maxWidth: "400px",
    textAlign: "center",
  },
  title: {
    marginBottom: "10px",
    color: "#333",
    fontSize: "24px",
  },
  subtitle: {
    marginBottom: "20px",
    color: "#777",
    fontSize: "14px",
  },
  input: {
    width: "100%",
    padding: "12px 15px",
    margin: "10px 0",
    border: "1px solid #ccc",
    borderRadius: "8px",
    fontSize: "16px",
  },
  button: {
    width: "100%",
    padding: "12px",
    background: "#667eea",
    color: "#fff",
    fontSize: "16px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    marginTop: "15px",
    transition: "background 0.3s",
  },
  error: {
    color: "#e74c3c",
    marginTop: "10px",
    fontSize: "14px",
  },
};

// export default App;

// import React, { useState } from "react";
// import Dash from "./Dash"; // Dashboard component after login

// function App() {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [formData, setFormData] = useState({ email: "", password: "" });
//   const [error, setError] = useState("");

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setError("");

//     try {
//       const response = await fetch("http://localhost:3050/api/users/login", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       });

//       const result = await response.json();

//       if (!response.ok) {
//         throw new Error(result.message || "Login failed");
//       }

//       // Optional: Save token if returned
//       if (result.token) {
//         localStorage.setItem("token", result.token);
//       }

//       setIsAuthenticated(true);
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   if (!isAuthenticated) {
//     return (
//       <div style={styles.container}>
//         <form style={styles.form} onSubmit={handleLogin}>
//           <h2 style={styles.title}>Welcome Back 👋</h2>
//           <p style={styles.subtitle}>Please login to access your dashboard</p>
//           <input
//             type="text"
//             name="email"
//             placeholder="Email"
//             value={formData.email}
//             onChange={handleChange}
//             style={styles.input}
//             required
//           />
//           <input
//             type="password"
//             name="password"
//             placeholder="Password"
//             value={formData.password}
//             onChange={handleChange}
//             style={styles.input}
//             required
//           />
//           <button type="submit" style={styles.button}>
//             Login
//           </button>
//           {error && <p style={styles.error}>{error}</p>}
//         </form>
//       </div>
//     );
//   }

//   return <Dash />;
// }

// const styles = {
//   container: {
//     minHeight: "100vh",
//     background: "linear-gradient(to right,rgb(245, 229, 145), #ec8a07)",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     padding: "20px",
//   },
//   form: {
//     background: "#fff",
//     padding: "40px",
//     borderRadius: "12px",
//     boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
//     width: "100%",
//     maxWidth: "400px",
//     textAlign: "center",
//   },
//   title: {
//     marginBottom: "10px",
//     color: "#333",
//     fontSize: "24px",
//   },
//   subtitle: {
//     marginBottom: "20px",
//     color: "#777",
//     fontSize: "14px",
//   },
//   input: {
//     width: "100%",
//     padding: "12px 15px",
//     margin: "10px 0",
//     border: "1px solid #ccc",
//     borderRadius: "8px",
//     fontSize: "16px",
//   },
//   button: {
//     width: "100%",
//     padding: "12px",
//     background: "#667eea",
//     color: "#fff",
//     fontSize: "16px",
//     border: "none",
//     borderRadius: "8px",
//     cursor: "pointer",
//     marginTop: "15px",
//     transition: "background 0.3s",
//   },
//   error: {
//     color: "#e74c3c",
//     marginTop: "10px",
//     fontSize: "14px",
//   },
// };

// export default App;

// new
// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import Dash from "./Dash";
// import "./App.css";

// function App() {
//   const API_URL = process.env.REACT_APP_API_URL;

//   const [loading, setLoading] = useState(true);
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [admin, setAdmin] = useState(null);

//   const [formData, setFormData] = useState({
//     email: "",
//     password: "",
//     rememberMe: false,
//   });

//   const [showPassword, setShowPassword] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   const handleChange = (e) => {
//     const { name, value, checked, type } = e.target;

//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   // -----------------------------
//   // Verify existing login
//   // -----------------------------
//   const verifyLogin = async () => {
//     const token = localStorage.getItem("token");

//     if (!token) {
//       setLoading(false);
//       return;
//     }

//     try {
//       const res = await fetch(`${API_URL}/admin/me`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!res.ok) {
//         throw new Error();
//       }

//       const data = await res.json();

//       setAdmin(data);
//       setIsAuthenticated(true);
//     } catch (err) {
//       localStorage.removeItem("token");
//       setAdmin(null);
//       setIsAuthenticated(false);
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     verifyLogin();
//   }, []);

//   // -----------------------------
//   // Login
//   // -----------------------------
//   const handleLogin = async (e) => {
//     e.preventDefault();

//     setError("");
//     setSuccess("");

//     try {
//       const res = await fetch(`${API_URL}/admin/adminlogin`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           email: formData.email,
//           password: formData.password,
//         }),
//       });

//       const data = await res.json();

//       if (!res.ok) {
//         setError(data.message || "Login failed");
//         return;
//       }

//       localStorage.setItem("token", data.token);

//       setSuccess("Login successful");

//       await verifyLogin();
//     } catch (err) {
//       setError("Network error.");
//     }
//   };

//   // -----------------------------
//   // Logout
//   // -----------------------------
//   const logout = () => {
//     localStorage.removeItem("token");

//     setAdmin(null);

//     setIsAuthenticated(false);

//     setFormData({
//       email: "",
//       password: "",
//       rememberMe: false,
//     });
//   };

//   // -----------------------------
//   // Loading
//   // -----------------------------
//   if (loading) {
//     return (
//       <div
//         style={{
//           height: "100vh",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           fontSize: 22,
//           fontWeight: "bold",
//         }}
//       >
//         Checking authentication...
//       </div>
//     );
//   }

//   // -----------------------------
//   // Dashboard
//   // -----------------------------
//   if (isAuthenticated) {
//     return (
//       <Dash
//         admin={admin}
//         logout={logout}
//       />
//     );
//   }

//   // -----------------------------
//   // Login Page
//   // -----------------------------
//   return (
//     <div className="login-container">

//       <form
//         className="login-box"
//         onSubmit={handleLogin}
//       >

//         <h2>Admin Login</h2>

//         <input
//           type="email"
//           name="email"
//           placeholder="Email"
//           value={formData.email}
//           onChange={handleChange}
//           required
//         />

//         <div className="password-field">

//           <input
//             type={showPassword ? "text" : "password"}
//             name="password"
//             placeholder="Password"
//             value={formData.password}
//             onChange={handleChange}
//             required
//           />

//           <button
//             type="button"
//             className="toggle-password"
//             onClick={() =>
//               setShowPassword(!showPassword)
//             }
//           >
//             {showPassword ? "🙈" : "👁️"}
//           </button>

//         </div>

//         <div className="remember-forgot">

//           <label>

//             <input
//               type="checkbox"
//               name="rememberMe"
//               checked={formData.rememberMe}
//               onChange={handleChange}
//             />

//             Remember Me

//           </label>

//           <Link
//             to="/forgot-password"
//             className="forgot-link"
//           >
//             Forgot Password?
//           </Link>

//         </div>

//         <button
//           className="login-btn"
//           type="submit"
//         >
//           Login
//         </button>

//         {error && (
//           <p className="error">
//             {error}
//           </p>
//         )}

//         {success && (
//           <p className="success">
//             {success}
//           </p>
//         )}

//       </form>

//     </div>
//   );
// }

// export default App;
